import { render, staticRenderFns } from "./ManifoldPicker.vue?vue&type=template&id=28ffb1ef&"
import script from "./ManifoldPicker.vue?vue&type=script&lang=js&"
export * from "./ManifoldPicker.vue?vue&type=script&lang=js&"
import style0 from "./ManifoldPicker.vue?vue&type=style&index=0&id=28ffb1ef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports